import { useRouteError } from 'react-router';
import { useEffect } from 'react';
import { ErrorFallback } from '@/components/ErrorBoundary';
import { analyticsError } from '@/lib/analytics-service';

/**
 * React Router errorElement — catches route-level errors that bypass
 * the class-based ErrorBoundary in main.tsx.
 */
export function RouteErrorBoundary() {
  const error = useRouteError();

  useEffect(() => {
    console.error('[RouteErrorBoundary]', error);
    analyticsError({
      errorType: error instanceof Error ? error.name : 'RouteError',
      errorMessage: (error instanceof Error ? error.message : String(error)).slice(0, 200),
      page: window.location.pathname,
    });
  }, [error]);

  return <ErrorFallback />;
}
